export default __webpack_public_path__ + "static/meet-john-9-3e3c91f9502b18aa6e40a915bbe2a013.webp";